import React, { useState } from 'react'
import "./layout.css"
import MainNav from '../navigation/route'
import Sidebar from '../components/sidebar/sidebar'
import { useSelector } from 'react-redux';

export default function Index() {
    const { isLoggedIn } = useSelector((state: any) => state.auth);
    const [isSidebar, setSideBar] = useState(false);
    return (
        <div className='layout-div'>
            <div className="body-div">
                {
                    isLoggedIn ? (
                        <div className="sidebar-div">
                            <Sidebar
                                islogin={isLoggedIn}
                                issidebar={isSidebar}
                                onChangeRoute={(e: any) => {
                                    if (e === "Dashboard") {
                                        setSideBar(false)
                                    } else {
                                        setSideBar(true)
                                    }
                                }} />
                        </div>
                    ) : <></>
                }
                <div className="content-div">
                    <MainNav />
                </div>
            </div>
        </div>
    )
}